import { getCookie } from '../../utils/get-cookie';
export function setHeaderFromCookie({ xCookieName, xHeaderName, ...config }) {
    const cookieValue = normalizeValue(getCookie(xCookieName));
    if (cookieValue) {
        return {
            ...config,
            headers: {
                ...(config.headers || {}),
                [xHeaderName]: cookieValue,
            },
        };
    }
    return config;
}
/**
 * По примеру как сделано в axios: https://github.com/axios/axios/blob/379fdebc46ede21815b7067830916eb612839e5e/lib/core/AxiosHeaders.js#L13
 */
function normalizeValue(cookieValue) {
    if (cookieValue === false || cookieValue == null) {
        return cookieValue;
    }
    return String(cookieValue);
}
